import { Box, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { withRouter } from 'react-router-dom';
import posthog from 'posthog-js';
import { translateCourse } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const CourseCard = ({ text, course }) => {
    const { user } = useSelector(state => state.user);

    const [lms, setLMS] = React.useState({});

    React.useEffect(() => {
        var temp = translateCourse(user.language_Code, { ...course });
        setLMS(temp);
    }, [course]);

    let className = 'success';
    let statusStub = 'OnTime';

    if (lms.status === 'completed' || lms.status === 'course_completed') {
        className = 'success';
        statusStub = 'completed';
    } else if (lms.status === 'in_progress' || lms.status === 'course_started') {
        className = 'warning';
        statusStub = 'inProgress';
    } else {
        className = 'grey';
        statusStub = 'notStarted';
    }

    const onClick = data => {
        const accelerate = data.lms === 'accelerate';
        if (accelerate) {
            posthog.capture('launched-learning', { course: data.lms, course_status: data.status, course_id: data.id });
            window.location.href = data.url;
        } else {
            window.open(data.url);
        }
    };

    return (
        <Box className={`box-${className} course-box pointer`} onClick={() => onClick(lms)}>
            <div className="flex flex-center">
                <label className={`label label-${className}`}>{text.card.statuses[statusStub]}</label>
                <div className="flex-grow"></div>
                <img src={`/dist/img/${lms.lms}-icon.png`} alt={`${lms.lms} logo`} />
            </div>
            <button data-testid="btn-explore-course" className="btn btn-link" onClick={() => onClick(lms)}>
                {lms.name}
            </button>
            <div className="description">{lms.description || lms.summary}</div>
            {lms.duration > 0 && (
                <div className="pull-right time">
                    <i className="fa fa-clock mr5" />
                    {StringHelpers.displayMinutes(lms.duration / 60)}
                </div>
            )}
        </Box>
    );
};

export default withRouter(CourseCard);
